import React, { useState, forwardRef, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import Alert from 'react-s-alert';

// import polygonIcon from '../../../assets/img/polygon.png'

const formatDate = (date, def = '', format = 'YYYY-MM-DD') => {
  try {
    const endDate = moment(date, 'YYYY-MM-DD HH:mm').format(format);

    if (_.isEmpty(date) && date === '') {
      return endDate === '';
    }

    if (endDate === 'Invalid date') {
      Alert.warning('Entered date is invalid');
    }

    const newDate = endDate === 'Invalid date' ? '' : endDate;

    return newDate;
  } catch (error) {
    return def;
  }
};

const CustomRender = forwardRef(({ onClick, btnClassName }, ref) => (
  <button
    type="button"
    ref={ref}
    className={`btn btn-primary cms-bg-color-primary cms-outline-primary  btn-sm px-2 py-1  ${
      !_.isEmpty(btnClassName) ? btnClassName : 'button-date'
    }`}
    onClick={onClick}
  >
    <i className="fa fa-lg fa-calendar" />
  </button>
));

CustomRender.propTypes = {
  onClick: PropTypes.instanceOf(Function),
  btnClassName: PropTypes.string,
};

CustomRender.defaultProps = {
  onClick: () => {},
  btnClassName: '',
};

const renderDateFormat = (showMonthYearPicker, withTime, showYearPicker) => {
  if (showYearPicker) {
    return 'YYYY';
  }
  if (showMonthYearPicker) {
    return 'YYYY-MM';
  }
  if (withTime) {
    return 'YYYY-MM-DD HH:mm';
  }
  return 'YYYY-MM-DD';
};

const inputMaskRenderFormat = (
  showMonthYearPicker,
  withTime,
  showYearPicker
) => {
  if (showYearPicker) {
    return '9999';
  }
  if (showMonthYearPicker) {
    return '9999-99';
  }
  if (withTime) {
    return '99/99/9999 99:99';
  }
  return '99/99/9999';
};

const renderPlaceHolder = (
  data,
  showMonthYearPicker,
  withTime,
  showYearPicker
) => {
  let placeHolder = '';
  if (data.length > 0) {
    return data;
  }

  placeHolder = () => {
    if (showYearPicker) {
      return 'YYYY';
    }
    if (showMonthYearPicker) {
      return 'YYYY-MM';
    }
    if (withTime) {
      return 'YYYY-MM-DD HH:MM';
    }
    return 'YYYY-MM-DD';
  };

  return placeHolder();
};

function DateInputPicker3({
  disabled,
  withTime,
  isRequired,
  placeholder,
  onChange,
  maxDate,
  minDate,
  value,
  openToDate,
  showYearPicker,
  showMonthYearPicker,
  otherProps,
  inputClassName,
  btnClassName,
}) {
  const [selected, setSelected] = useState(null);
  const customRenderRef = useRef();

  const handleChangeInput = e => {
    setSelected(e.target.value);
  };

  const handleChangePicker = e => {
    const newVal = formatDate(
      e,
      '',
      renderDateFormat(showMonthYearPicker, withTime, showYearPicker)
    );
    onChange({ target: { value: newVal } });
  };

  const handleUpdateActual = e => {
    const newVal = formatDate(
      e.target.value,
      selected,
      renderDateFormat(showMonthYearPicker, withTime, showYearPicker)
    );
    if (new Date(newVal) < maxDate && new Date(newVal) >= minDate) {
      setSelected(newVal);
      onChange({ target: { value: newVal } });
      return;
    }

    // setSelected('');
    onChange({ target: { value: newVal } });
  };

  useEffect(() => {
    setSelected(value);
  }, [value]);

  return (
    <div className="input-group">
      <InputMask
        onChange={handleChangeInput}
        onBlur={handleUpdateActual}
        maskChar={null}
        disabled={disabled}
        required={isRequired}
        placeholder={renderPlaceHolder(
          placeholder,
          showMonthYearPicker,
          withTime,
          showYearPicker
        )}
        mask={inputMaskRenderFormat(
          showMonthYearPicker,
          withTime,
          showYearPicker
        )}
        className={`form-control ${inputClassName}`}
        value={selected || ''}
      />
      <div className="input-group-btn ">
        <DatePicker
          wrapperClassName="date-picker-wrapper"
          selected={new Date(value || openToDate)}
          // selected={value || new Date()}
          showMonthYearPicker={showMonthYearPicker}
          onChange={handleChangePicker}
          showTimeSelect={withTime}
          timeIntervals={15}
          dateFormat="yyyy"
          timeFormat="HH:mm"
          maxDate={maxDate}
          minDate={minDate}
          placeholder={renderPlaceHolder}
          showYearPicker={showYearPicker}
          popperPlacement="bottom-end"
          customInput={
            <CustomRender ref={customRenderRef} btnClassName={btnClassName} />
          }
          {...otherProps}
        />
      </div>
    </div>
  );
}

DateInputPicker3.defaultProps = {
  disabled: false,
  showMonthYearPicker: false,
  withTime: false,
  isRequired: false,
  placeholder: '',
  maxDate: new Date('3000-01-01'),
  minDate: new Date('1900-01-01'),
  openToDate: new Date(),
  value: '',
  otherProps: '',
  inputClassName: '',
  btnClassName: '',
  showYearPicker: false,
};

/* eslint-disable */
DateInputPicker3.propTypes = {
  disabled: PropTypes.bool,
  showMonthYearPicker: PropTypes.bool,
  withTime: PropTypes.bool,
  isRequired: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.instanceOf(Function).isRequired,
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  openToDate: PropTypes.instanceOf(Date),
  showYearPicker: PropTypes.bool,
  value: PropTypes.string,
  otherProps: PropTypes.node,
  inputClassName: PropTypes.string,
  btnClassName: PropTypes.string,
  showYearPicker: PropTypes.bool,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(DateInputPicker3);
